import { clamp } from '@hotjar/insights-common/lib/number';

export type ClickRegionWithZIndex = [number, number, number, number, number, number];

export interface ClickRegionPosition {
  left: number;
  top: number;
  width: number;
  height: number;
  zIndex: number;
  clicksCount: number;
  clicksPercentage: number;
}

export interface CalculateRegionPositionProps {
  coords: ClickRegionWithZIndex;
  heatmapWidth: number;
  actualWidth: number;
  totalClickCount: number;
}

export const calculateRegionPosition = ({
  coords,
  heatmapWidth,
  actualWidth,
  totalClickCount,
}: CalculateRegionPositionProps): ClickRegionPosition => {
  const zoom = clamp(actualWidth / heatmapWidth, 0, 1);
  let left = coords[0] * zoom;
  const top = coords[1] * zoom;
  let width = coords[2] * zoom;
  const height = coords[3] * zoom;

  if (left < 0) {
    width += left;
    left = 0;
  }

  return {
    left,
    top,
    width,
    height,
    clicksCount: coords[4],
    clicksPercentage: totalClickCount > 0 ? (coords[4] * 100) / totalClickCount : 0,
    zIndex: coords[5],
  };
};

export const labelBottom = (top: number): boolean => top < 35;

export const labelRight = (left: number, deviceWidth: number): boolean => left + 180 > deviceWidth;

export const includeZIndexToRegions = (
  clickRegions: Array<HeatmapAPI.ClickRegion>,
): Array<ClickRegionWithZIndex> => {
  let zIndex = 100;
  const regionsSortedBySizeDesc = [...clickRegions].sort((a, b) => b[2] * b[3] - a[2] * a[3]);

  return regionsSortedBySizeDesc.map((region) => {
    const regionWithZIndex = [...region, zIndex] as ClickRegionWithZIndex;
    zIndex += 1;
    return regionWithZIndex;
  });
};
